
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/major-events",
      function () {
        return require("private-next-pages/major-events.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/major-events"])
      });
    }
  